import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import './ExploreMoreSection.css';
import { getLanguage } from 'react-switch-lang';
import en from '../en.json';
import ma from '../ma.json';



import appIcon from '../assets/home_icons/Home Page_website-26.png';
import resourceIcon from '../assets/home_icons/Home Page_website-27.png';
import shopIcon from '../assets/home_icons/Home Page_website-28.png';
import sadhakIcon from '../assets/home_icons/Home Page_website-29.png';
const translationData = { en: en, mr: ma };
const ExploreMoreSection = () => {

  const [showComingSoon, setShowComingSoon] = useState(false);
  const history = useHistory();
  const [language, setLanguage] = useState(() => getLanguage() || 'en');
  const t = (key) => {
    const langKey = language === 'ma' || language === 'mr' ? 'mr' : 'en';
    return translationData[langKey]?.[key] || '';
  };
  useEffect(() => {
    const checkLang = () => {
      const current = getLanguage() || 'en';
      setLanguage(prev => prev !== current ? current : prev);
    };
    checkLang();
    const interval = setInterval(checkLang, 500);
    window.addEventListener('storage', checkLang);
    return () => { clearInterval(interval); window.removeEventListener('storage', checkLang); };
  }, []);

  const handleComingSoon = () => {
    setShowComingSoon(true);
    setTimeout(() => setShowComingSoon(false), 2500);
  };
  const ExploreMoreCard = ({ image, title, subtitle, link, external }) => {
    const handleCardClick = () => {
      if (!link) { handleComingSoon(); return; }
      if (external) { window.open(link, '_blank', 'noopener,noreferrer'); return; }
      history.push(link);
    };

    return (
    <div className="explore-more-card" onClick={handleCardClick} style={{ cursor: 'pointer' }}>
      
      <div className="explore-more-card-icon">
        <img src={image} alt={title} />
      </div>

      <div className="explore-more-card-title">{title}</div>
      <div className="explore-more-card-subtitle">{subtitle}</div>

      {link ? (
        external ? (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="explore-more-card-arrow"
            onClick={e => e.stopPropagation()}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M5 12h14M13 5l7 7-7 7"
                stroke="#9d0b0e"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        ) : (
          <Link to={link} className="explore-more-card-arrow" onClick={e => e.stopPropagation()}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M5 12h14M13 5l7 7-7 7"
                stroke="#9d0b0e"
                strokeWidth="2.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        )
      ) : (
        <div className="explore-more-card-arrow"
            onClick={(e) => { e.stopPropagation(); handleComingSoon(); }}
            style={{ cursor: "pointer" }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M5 12h14M13 5l7 7-7 7"
              stroke="#9d0b0e"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      )}

    </div>
  );
};

  return (
    <div className="explore-more-section">
      <p className="explore-more-subtitle">{t('explore_more_subtitle')}</p>
      <h2 className="explore-more-title">
        {t('explore_more_title')}
      </h2>

      <div className="explore-more-grid">

        {/* ✅ Manatarag App with Play Store Link */}
        <ExploreMoreCard
          image={appIcon}
          title={t('explore_more_app_title')}
          subtitle={t('explore_more_app_sub')}
          link="https://play.google.com/store/apps/details?id=com.snt.manashakti&hl=en_IN&pli=1"
          external={true}
        />

        <ExploreMoreCard
          image={resourceIcon}
          title={t('explore_more_resources_title')}
          subtitle={t('explore_more_resources_sub')}
          link="/download"
        />

        <ExploreMoreCard
          image={shopIcon}
          title={t('explore_more_shop_title')}
          subtitle={t('explore_more_shop_sub')}
          link="/products"
        />

        {/**
        <ExploreMoreCard
          image={sadhakIcon}
          title={t('explore_more_sadhak_title')}
          subtitle={t('explore_more_sadhak_sub')}
        />
        */}

      </div>
        {showComingSoon && (
          <div className="coming-soon-toast">
            {t('coming_soon_message')}
          </div>
        )}
    </div>
  );
};

export default ExploreMoreSection;